import { ROUTE_PATHS } from '../config/navigation';
import managedContent from './managedContent.json';

const routePathMap = {
  dashboard: ROUTE_PATHS.dashboard,
  directory: ROUTE_PATHS.directory,
  announcements: ROUTE_PATHS.announcements,
  documents: ROUTE_PATHS.documents,
  surveys: ROUTE_PATHS.surveys,
  innovation: ROUTE_PATHS.innovation,
  events: ROUTE_PATHS.events
};

const resolvePath = (item) => item.path || routePathMap[item.pathKey] || ROUTE_PATHS.dashboard;

export const hydrateCorporateContent = (content) => ({
  managementMessages: (content.managementMessages || []).map((item) => ({
    ...item,
    ctaPath: resolvePath(item)
  })),
  cultureHighlights: content.cultureHighlights || [],
  corporateQuickAccess: (content.corporateQuickAccess || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  })),
  quickContacts: content.quickContacts || [],
  systemLinks: content.systemLinks || [],
  participationLinks: (content.participationLinks || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  }))
});

const corporateContent = hydrateCorporateContent(managedContent.corporate);

export const {
  managementMessages,
  cultureHighlights,
  corporateQuickAccess,
  quickContacts,
  systemLinks,
  participationLinks
} = corporateContent;

export const documentCategories = [
  {
    id: 'all',
    queryValue: 'tum-kaynaklar',
    title: 'Tüm Kaynaklar',
    shortLabel: 'Tümü',
    description: 'Doküman merkezindeki tüm içerikler',
    icon: 'bx bx-grid-alt',
    keywords: []
  },
  {
    id: 'policies',
    queryValue: 'politika-prosedur',
    title: 'Politika ve Prosedürler',
    shortLabel: 'Politikalar',
    description: 'Kurumsal politika, prosedür, yönetmelik ve uyum belgeleri',
    icon: 'bx bx-shield-quarter',
    keywords: ['politika', 'prosedür', 'yönetmelik', 'iso', 'güvenlik', 'kalite', 'iş sağlığı']
  },
  {
    id: 'forms',
    queryValue: 'form-sablon',
    title: 'Formlar, Şablonlar ve Dilekçeler',
    shortLabel: 'Formlar',
    description: 'Operasyonel ve idari süreçlerde kullanılan doldurulabilir kaynaklar',
    icon: 'bx bx-detail',
    keywords: ['form', 'şablon', 'dilekçe', 'talep', 'başvuru']
  },
  {
    id: 'corporate',
    queryValue: 'kurumsal-kaynaklar',
    title: 'Kurumsal Kaynaklar',
    shortLabel: 'Kurumsal',
    description: 'Çalışan el kitabı, şirket sunumu, organizasyon yapısı ve tanıtım içerikleri',
    icon: 'bx bx-building-house',
    keywords: ['çalışan', 'el kitabı', 'organizasyon', 'şirket', 'sunum', 'tanıtım']
  }
];

export const featuredDocumentCollections = [
  {
    id: 'policies',
    title: 'Kurumsal Politika ve Prosedürler',
    description: 'Güncel kurumsal standartlar, kalite belgeleri ve uyum dokümanı için ana erişim noktası.',
    categoryId: 'policies',
    ctaLabel: 'Politikalara git'
  },
  {
    id: 'forms',
    title: 'Formlar ve Şablonlar',
    description: 'Sık kullanılan başvuru, talep ve operasyon şablonlarını tek akışta bulun.',
    categoryId: 'forms',
    ctaLabel: 'Formları görüntüle'
  },
  {
    id: 'corporate',
    title: 'Kurumsal Tanıtım İçeriği',
    description: 'Kurum kültürü, organizasyon yapısı ve ortak dil için kullanılan temel kaynaklar.',
    categoryId: 'corporate',
    ctaLabel: 'Kurumsal kaynakları aç'
  }
];

export const getCorporateContentFallback = () => ({
  managementMessages: [...managementMessages],
  cultureHighlights: [...cultureHighlights],
  corporateQuickAccess: [...corporateQuickAccess],
  quickContacts: [...quickContacts],
  systemLinks: [...systemLinks],
  participationLinks: [...participationLinks]
});

export default corporateContent;
